import { useEffect, useState } from 'react';
import { getBasketCookie, removeBasketCookie } from 'shared-utils';

import type { BasketDetails } from 'shared-types/Basket';

type UseReservationBasketIdParams = {
  basketDetails?: BasketDetails;
  propertyId: number;
  language: string;
  fetchBasketDetails: (
    propertyId: number,
    basketId: number | string,
    language: string
  ) => Promise<unknown>;
};

type UseReservationBasketIdResult = {
  basketId: string | undefined;
  basketNotReady: boolean;
};

export function useReservationBasketId({
  basketDetails,
  propertyId,
  language,
  fetchBasketDetails,
}: UseReservationBasketIdParams): UseReservationBasketIdResult {
  const [staleBasketId, setStaleBasketId] = useState<string | undefined>(undefined);
  const cookieBasketId = getBasketCookie();
  const basketId = cookieBasketId && cookieBasketId !== staleBasketId ? cookieBasketId : undefined;
  const basketNotReady = Boolean(basketId) && !basketDetails;

  const [hydrationSettled, setHydrationSettled] = useState(false);

  useEffect(() => {
    if (basketId && !basketDetails && !hydrationSettled) {
      Promise.resolve(fetchBasketDetails(propertyId, basketId, language)).finally(() =>
        setHydrationSettled(true)
      );
    }
  }, [basketId, basketDetails, hydrationSettled, propertyId, language, fetchBasketDetails]);

  useEffect(() => {
    if (hydrationSettled && basketId && !basketDetails) {
      removeBasketCookie();
      setStaleBasketId(basketId);
    }
  }, [hydrationSettled, basketId, basketDetails]);

  return { basketId, basketNotReady };
}
